import { render, staticRenderFns } from "./PublicMarketplaceSellerList.vue?vue&type=template&id=274f75c9&"
import script from "./PublicMarketplaceSellerList.vue?vue&type=script&lang=js&"
export * from "./PublicMarketplaceSellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports